export default __webpack_public_path__ + "static/media/helecho.20ee46b8.png";